module.exports = __webpack_public_path__ + "static/media/p2008ulse.a787ebee.jpg";